<script setup lang="ts">
import { useStore } from '@/store/store'
const store = useStore()
store.commit('setPageTitle', 'Gestion des rôles')
</script>

<template>
  <q-page flex> Gestion des rôles </q-page>
</template>
